import { IntlAction, updateIntl } from 'react-intl-redux';

import { localeMap } from '../core';

/**
 * Checks if the given locale param exists in data map, and passes to react-intl-redux.
 *
 * @name setLocale
 * @function
 * @param {string} name - IETF language tag
 * @returns {IntlAction}
 */
export function setLocale(name: string): IntlAction {
  if (name in localeMap) {
    return updateIntl({
      locale: name,
      messages: localeMap[name]
    });
  }
  throw new Error(`Locale ${name} is not provided`);
}
